import $ from "jquery";

const HEADER_SELECTOR = ".nav_desktop_mz, .nav_desktop_mz_solid";
const TOGGLE_SELECTOR = "[data-nav-mz-drawer-toggle]";
const SUBMENU_TOGGLE_SELECTOR = ".nav_desktop_mz__submenu_toggle, .nav_desktop_mz_solid__submenu_toggle";
const SUBMENU_OPEN_CLASS = "nav_desktop_mz__menu_item--submenu-open";
const SUBMENU_OPEN_CLASS_SOLID = "nav_desktop_mz_solid__menu_item--submenu-open";

function closeAll() {
  $(HEADER_SELECTOR).removeClass("is-menu-open");
  $(HEADER_SELECTOR).find(TOGGLE_SELECTOR).removeClass("active").attr("aria-expanded", "false");
  $(HEADER_SELECTOR)
    .find("." + SUBMENU_OPEN_CLASS + ", ." + SUBMENU_OPEN_CLASS_SOLID)
    .removeClass(SUBMENU_OPEN_CLASS)
    .removeClass(SUBMENU_OPEN_CLASS_SOLID)
    .find(SUBMENU_TOGGLE_SELECTOR)
    .attr("aria-expanded", "false");
  $("html").removeClass("no_scroll");
}

function isMobileDrawerViewport() {
  return window.matchMedia("(max-width: 789px)").matches;
}

function toggleHeader($header) {
  if (!isMobileDrawerViewport()) {
    return;
  }
  const open = $header.hasClass("is-menu-open");
  const $toggle = $header.find(TOGGLE_SELECTOR);
  if (open) {
    $header.removeClass("is-menu-open");
    $toggle.removeClass("active").attr("aria-expanded", "false");
    $("html").removeClass("no_scroll");
  } else {
    closeAll();
    $header.addClass("is-menu-open");
    $toggle.addClass("active").attr("aria-expanded", "true");
    $("html").addClass("no_scroll");
  }
}

$(document).on("click", TOGGLE_SELECTOR, function (e) {
  e.preventDefault();
  const $header = $(this).closest(HEADER_SELECTOR);
  if ($header.length) {
    toggleHeader($header);
  }
});

$(document).on("click", SUBMENU_TOGGLE_SELECTOR, function (e) {
  if (!isMobileDrawerViewport()) {
    return;
  }

  e.preventDefault();
  e.stopPropagation();

  const $btn = $(this);
  const $li = $btn.closest("li");
  if (!$li.length) {
    return;
  }

  const isSolid = $li.hasClass("nav_desktop_mz_solid__menu_item--has-children");
  const openClass = isSolid ? SUBMENU_OPEN_CLASS_SOLID : SUBMENU_OPEN_CLASS;
  const open = $li.hasClass(openClass);

  $li.toggleClass(openClass, !open);
  $btn.attr("aria-expanded", (!open).toString());
});

$(document).on("keydown", function (e) {
  if (e.key !== "Escape") {
    return;
  }
  if ($(HEADER_SELECTOR + ".is-menu-open").length) {
    closeAll();
  }
});

$(document).on(
  "click",
  ".nav_desktop_mz.is-menu-open .nav_desktop_mz__menu a, .nav_desktop_mz_solid.is-menu-open .nav_desktop_mz_solid__menu a",
  function () {
    if (isMobileDrawerViewport()) {
      closeAll();
    }
  }
);

$(window).on("resize", function () {
  if (!isMobileDrawerViewport()) {
    closeAll();
  }
});
